import React from 'react'

import Layout from './components/Layout'
import 'normalize.css/normalize.css'
import './styles/index.scss'

const App = () => <Layout />

export default App
